"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useRateLimiter = require("./useRateLimiter.cjs");
function useRateLimitedCallback(fn, options) {
  const rateLimitedFn = useRateLimiter.useRateLimiter(fn, options).maybeExecute;
  return react.useCallback((...args) => rateLimitedFn(...args), [rateLimitedFn]);
}
exports.useRateLimitedCallback = useRateLimitedCallback;
//# sourceMappingURL=useRateLimitedCallback.cjs.map
